__turbopack_context__.v({
  "active": "resultsColumn-module-scss-module__SHtqHG__active",
  "activeLink": "resultsColumn-module-scss-module__SHtqHG__activeLink",
  "activeResultItem": "resultsColumn-module-scss-module__SHtqHG__activeResultItem",
  "beta": "resultsColumn-module-scss-module__SHtqHG__beta",
  "burgerButton": "resultsColumn-module-scss-module__SHtqHG__burgerButton",
  "cfrVariant": "resultsColumn-module-scss-module__SHtqHG__cfrVariant",
  "column": "resultsColumn-module-scss-module__SHtqHG__column",
  "columnTitle": "resultsColumn-module-scss-module__SHtqHG__columnTitle",
  "creditflowVariant": "resultsColumn-module-scss-module__SHtqHG__creditflowVariant",
  "headerContainer": "resultsColumn-module-scss-module__SHtqHG__headerContainer",
  "headerContent": "resultsColumn-module-scss-module__SHtqHG__headerContent",
  "headerScroll": "resultsColumn-module-scss-module__SHtqHG__headerScroll",
  "headerTopRow": "resultsColumn-module-scss-module__SHtqHG__headerTopRow",
  "hideMarketDataBtnWithOpenedSearchMenu": "resultsColumn-module-scss-module__SHtqHG__hideMarketDataBtnWithOpenedSearchMenu",
  "hideSearchOnMobileView": "resultsColumn-module-scss-module__SHtqHG__hideSearchOnMobileView",
  "iconContainer": "resultsColumn-module-scss-module__SHtqHG__iconContainer",
  "iconContainerPremiumization": "resultsColumn-module-scss-module__SHtqHG__iconContainerPremiumization",
  "innerMenuWrapper": "resultsColumn-module-scss-module__SHtqHG__innerMenuWrapper",
  "link": "resultsColumn-module-scss-module__SHtqHG__link",
  "linksButtonsContainer": "resultsColumn-module-scss-module__SHtqHG__linksButtonsContainer",
  "linksWrapper": "resultsColumn-module-scss-module__SHtqHG__linksWrapper",
  "menuOpenedOnMobileView": "resultsColumn-module-scss-module__SHtqHG__menuOpenedOnMobileView",
  "new": "resultsColumn-module-scss-module__SHtqHG__new",
  "noResultsBlock": "resultsColumn-module-scss-module__SHtqHG__noResultsBlock",
  "noResultsForFirstColumn": "resultsColumn-module-scss-module__SHtqHG__noResultsForFirstColumn",
  "panelLink": "resultsColumn-module-scss-module__SHtqHG__panelLink",
  "premiumizationLinksContainer": "resultsColumn-module-scss-module__SHtqHG__premiumizationLinksContainer",
  "resultsBlock": "resultsColumn-module-scss-module__SHtqHG__resultsBlock",
  "resultsItem": "resultsColumn-module-scss-module__SHtqHG__resultsItem",
  "searchResultOpenedOnMobileView": "resultsColumn-module-scss-module__SHtqHG__searchResultOpenedOnMobileView",
  "solutionsButton": "resultsColumn-module-scss-module__SHtqHG__solutionsButton",
  "spinner": "resultsColumn-module-scss-module__SHtqHG__spinner",
  "spinnerOverlay": "resultsColumn-module-scss-module__SHtqHG__spinnerOverlay",
  "title": "resultsColumn-module-scss-module__SHtqHG__title",
  "toolbarContainer": "resultsColumn-module-scss-module__SHtqHG__toolbarContainer",
  "transparentBackground": "resultsColumn-module-scss-module__SHtqHG__transparentBackground",
  "userProPlan": "resultsColumn-module-scss-module__SHtqHG__userProPlan",
  "withoutLogin": "resultsColumn-module-scss-module__SHtqHG__withoutLogin",
});
